import React, {Component} from "react"
import {observer, intercept, action, observable} from "mobx-react"
import {NavLink} from "react-router-dom"
import app from "app.controller"
import shop from "shop/shop"
import languageStore from "stores/languageStore"
import "./Menu.scss"

@observer
export default class Menu extends Component {

  state = {
    menu:    false,
    current: false,
  }

  componentDidMount() {
    app.language.changed.add( this.load )
    this.load()
  }

  load = () => {
    const { currentLanguage } = languageStore
    let { slug }              = this.props
    shop.fetchFromWordPress( `menu-locations/${slug}${app.getQueryLanguageParameter("?")}` )
      .then( menus => menus[ 0 ] )
      .then( (layout) => {
        this.setState( { menu: layout.acf.menu } )
      } )
      .catch( err => {
        console.info( `Menu couldn't load: `, err )
      } )
  }

  componentWillUnmount() {
    app.language.changed.remove( this.load )
  }

  show = entry => {
    this.setState( { current: entry } )
  }

  hide = entry => {
    this.setState( { current: false } )
  }

  render() {
    const { menu, current } = this.state
    return (
      <div className="Menu">
        <ul className="nav nav-main relative ">
          {menu && menu.map( entry => (
            <li className="level-0" key={entry.name} onMouseOver={() => {this.show( entry )}} onMouseOut={() => {this.hide( entry )}}>
              <NavLink to={entry.url}>{entry.name}</NavLink>
              {entry.links &&
              <div className={`dropdown ${current === entry && "active"}`}>
                <div className="dropdown-inner">
                  {entry.image && entry.image_url &&
                  <NavLink className="nav-image" onClick={() => {this.hide( entry )}} to={entry.image_url}><img src={entry.image} width="250" className="fl "/></NavLink>}
                  {entry.image && !entry.image_url && <img src={entry.image} width="250" className="fl "/>}
                  <ul>
                    {entry.links.map( e => (<li key={`${entry.name}-${e.name}`}><NavLink onClick={() => {this.hide( entry )}} to={e.url}>{e.name}</NavLink></li>) )}
                  </ul>
                </div>
              </div>}
            </li>
          ) )}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MenuACF/Menu.js